export default {
      id: "ic-game-arrow-right-white-usage",
      viewBox: "0 0 30 26",
      url: "/" + "images/icons.3.109.2.svg#ic-game-arrow-right-white-usage",
      toString: function () {
        return this.url;
      }
    }